import { useState, useRef, useCallback, useEffect } from "react";

const PETS = [
  { name: "Vorki", source: "Vorkath", rate: 3000, cat: "boss" },
  { name: "Baby Mole", source: "Giant Mole", rate: 3000, cat: "boss" },
  { name: "Hellpuppy", source: "Cerberus", rate: 3000, cat: "boss" },
  { name: "Prince Black Dragon", source: "King Black Dragon", rate: 3000, cat: "boss" },
  { name: "Pet Kraken", source: "Kraken", rate: 3000, cat: "boss" },
  { name: "Pet Smoke Devil", source: "Thermonuclear", rate: 3000, cat: "boss" },
  { name: "Kalphite Princess", source: "Kalphite Queen", rate: 3000, cat: "boss" },
  { name: "Noon", source: "Grotesque Guardians", rate: 3000, cat: "boss" },
  { name: "Sraracha", source: "Sarachnis", rate: 3000, cat: "boss" },
  { name: "Ikkle Hydra", source: "Alchemical Hydra", rate: 3000, cat: "boss" },
  { name: "Butch", source: "Vardorvis", rate: 3000, cat: "boss" },
  { name: "Scurry", source: "Scurrius", rate: 3000, cat: "boss" },
  { name: "Moxi", source: "Amoxliatl", rate: 3000, cat: "boss" },
  { name: "Nid", source: "Araxxor", rate: 3000, cat: "boss" },
  { name: "Gull", source: "Shellbane Gryphon", rate: 3000, cat: "boss" },
  { name: "Pet Snakeling", source: "Zulrah", rate: 4000, cat: "boss" },
  { name: "Dagannoth Prime Jr.", source: "Dagannoth Prime", rate: 5000, cat: "boss" },
  { name: "Dagannoth Rex Jr.", source: "Dagannoth Rex", rate: 5000, cat: "boss" },
  { name: "Dagannoth Supreme Jr.", source: "Dagannoth Supreme", rate: 5000, cat: "boss" },
  { name: "Pet Dark Core", source: "Corporeal Beast", rate: 5000, cat: "boss" },
  { name: "General Graardor Jr.", source: "General Graardor", rate: 5000, cat: "boss" },
  { name: "K'ril Tsutsaroth Jr.", source: "K'ril Tsutsaroth", rate: 5000, cat: "boss" },
  { name: "Kree'arra Jr.", source: "Kree'arra", rate: 5000, cat: "boss" },
  { name: "Zilyana Jr.", source: "Commander Zilyana", rate: 5000, cat: "boss" },
  { name: "Phoenix", source: "Wintertodt", rate: 5000, cat: "boss" },
  { name: "Baron", source: "Duke Sucellus", rate: 2500, cat: "boss" },
  { name: "Lil'viathan", source: "The Leviathan", rate: 2500, cat: "boss" },
  { name: "Muphin", source: "Phantom Muspah", rate: 2500, cat: "boss" },
  { name: "Yami", source: "Yama", rate: 2500, cat: "boss" },
  { name: "Abyssal Orphan", source: "Abyssal Sire", rate: 2560, cat: "boss" },
  { name: "Smolcano", source: "Zalcano", rate: 2250, cat: "boss" },
  { name: "Wisp", source: "The Whisperer", rate: 2000, cat: "boss" },
  { name: "Youngllef", source: "Corrupted Gauntlet", rate: 800, cat: "boss" },
  { name: "Little Nightmare", source: "Phosani's Nightmare", rate: 1400, cat: "boss" },
  { name: "Nexling", source: "Nex", rate: 500, cat: "boss" },
  { name: "Huberte", source: "The Hueycoatl", rate: 400, cat: "boss" },
  { name: "Tiny Tempor", source: "Tempoross", rate: 8000, cat: "boss" },
  { name: "Scorpia's Offspring", source: "Scorpia", rate: 2016, cat: "wildy" },
  { name: "Callisto Cub", source: "Callisto", rate: 1500, cat: "wildy" },
  { name: "Venenatis Spiderling", source: "Venenatis", rate: 1500, cat: "wildy" },
  { name: "Vet'ion Jr.", source: "Vet'ion", rate: 1500, cat: "wildy" },
  { name: "Chaos Elemental Jr.", source: "Chaos Elemental", rate: 300, cat: "wildy" },
  { name: "Olmlet", source: "Chambers of Xeric", rate: 53, cat: "raid" },
  { name: "Lil' Zik", source: "Theatre of Blood", rate: 650, cat: "raid" },
  { name: "Tumeken's Guardian", source: "Tombs of Amascut", rate: 350, cat: "raid" },
  { name: "Skotos", source: "Skotizo", rate: 65, cat: "special" },
  { name: "Tzrek-jad", source: "TzHaar Fight Cave", rate: 200, cat: "special" },
  { name: "Jal-nib-rek", source: "Inferno", rate: 100, cat: "special" },
  { name: "Smol Heredit", source: "Sol Heredit", rate: 200, cat: "special" },
  { name: "Rock Golem", source: "Mining", rate: 741000, cat: "skill", rd: "~1/741k" },
  { name: "Heron", source: "Fishing", rate: 257770, cat: "skill", rd: "~1/258k" },
  { name: "Beaver", source: "Woodcutting", rate: 264367, cat: "skill", rd: "~1/264k" },
  { name: "Giant Squirrel", source: "Agility", rate: 36842, cat: "skill", rd: "~1/37k" },
  { name: "Tangleroot", source: "Farming", rate: 281040, cat: "skill", rd: "~1/281k" },
  { name: "Rocky", source: "Thieving", rate: 257211, cat: "skill", rd: "~1/257k" },
  { name: "Rift Guardian", source: "Runecrafting", rate: 298635, cat: "skill", rd: "~1/299k" },
  { name: "Baby Chinchompa", source: "Hunter", rate: 131395, cat: "skill", rd: "~1/131k" },
];

const CATS = [
  { id: "all", label: "All Pets" }, { id: "boss", label: "Boss" }, { id: "wildy", label: "Wildy" },
  { id: "raid", label: "Raids" }, { id: "special", label: "Special" }, { id: "skill", label: "Skilling" },
];

const P = {
  sp: { background: "linear-gradient(180deg,#3b3424,#2d2618 50%,#252015)", border: "2px solid #5c5040", borderRadius: 0, boxShadow: "inset 0 1px 0 #6b604a,inset 0 -1px 0 #1a1610,0 2px 8px rgba(0,0,0,0.6)" },
  sb: { background: "linear-gradient(180deg,#5c5040,#3b3424)", border: "2px solid #6b604a", borderBottom: "2px solid #2a2318", borderRight: "2px solid #2a2318", color: "#ff981f", fontFamily: "'VT323',monospace", cursor: "pointer", textShadow: "1px 1px 0 #000", letterSpacing: 1 },
  yt: { color: "#ffff00", textShadow: "1px 1px 0 #000", fontFamily: "'VT323',monospace" },
  ot: { color: "#ff981f", textShadow: "1px 1px 0 #000", fontFamily: "'VT323',monospace" },
};
const fmt = n => n.toLocaleString();
const rdp = p => p.rd || `1/${fmt(p.rate)}`;
const cc = { boss: "#ff981f", wildy: "#ff3333", raid: "#aa44ff", special: "#ffff00", skill: "#00ff00" };

function genId() { return "User" + String(Math.floor(1000 + Math.random() * 9000)); }

// localStorage helpers
function lsGet(key, fallback = null) {
  try { const v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch { return fallback; }
}
function lsSet(key, val) {
  try { localStorage.setItem(key, JSON.stringify(val)); } catch {}
}

export default function App() {
  const [sel, setSel] = useState(PETS[0]);
  const [result, setResult] = useState(null);
  const [rolls, setRolls] = useState(0);
  const [wins, setWins] = useState(0);
  const [rolled, setRolled] = useState(null);
  const [rolling, setRolling] = useState(false);
  const [auto, setAuto] = useState(false);
  const [speed, setSpeed] = useState(1);
  const [sow, setSow] = useState(true);
  const [dry, setDry] = useState(0);
  const [best, setBest] = useState(null);
  const [cat, setCat] = useState("all");
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [chat, setChat] = useState([{ t: "Welcome to the Pet Roll Simulator.", c: "#0000ff" }]);
  const [tab, setTab] = useState("collection");
  const [hoverPet, setHoverPet] = useState(null);
  const [confirmReset, setConfirmReset] = useState(false);
  const [collection, setCollection] = useState({});
  const [playerId, setPlayerId] = useState("");
  const [playerName, setPlayerName] = useState("");
  const [editingName, setEditingName] = useState(false);
  const [nameInput, setNameInput] = useState("");
  const [globalBoard, setGlobalBoard] = useState([]);
  const [loadingBoard, setLoadingBoard] = useState(false);

  const aRef = useRef(null);
  const arRef = useRef(false);
  const sowRef = useRef(sow);
  const spRef = useRef(speed);
  const dRef = useRef(0);
  const rRef = useRef(sel.rate);
  const pRef = useRef(sel);
  const ceRef = useRef(null);
  const collRef = useRef(collection);
  const saveTimer = useRef(null);

  useEffect(() => { rRef.current = sel.rate; pRef.current = sel; }, [sel]);
  useEffect(() => { sowRef.current = sow; }, [sow]);
  useEffect(() => { spRef.current = speed; }, [speed]);
  useEffect(() => { arRef.current = auto; }, [auto]);
  useEffect(() => { ceRef.current?.scrollIntoView({ behavior: "smooth" }); }, [chat]);
  useEffect(() => { collRef.current = collection; }, [collection]);

  // Init from localStorage
  useEffect(() => {
    let profile = lsGet("petroll-profile");
    if (!profile) {
      const id = genId();
      profile = { id, name: id };
      lsSet("petroll-profile", profile);
    }
    setPlayerId(profile.id);
    setPlayerName(profile.name);
    const coll = lsGet("petroll-collection", {});
    setCollection(coll);
  }, []);

  // Save collection debounced + push to leaderboard API
  const schedSave = useCallback(() => {
    if (saveTimer.current) clearTimeout(saveTimer.current);
    saveTimer.current = setTimeout(async () => {
      const coll = collRef.current;
      lsSet("petroll-collection", coll);
      // Push to API
      const entries = Object.entries(coll).filter(([, v]) => v.count > 0);
      const unique = entries.length;
      const totalDrops = entries.reduce((s, [, v]) => s + v.count, 0);
      const bestKc = entries.length > 0 ? Math.min(...entries.map(([, v]) => v.bestKc)) : null;
      const bestPet = bestKc !== null ? entries.find(([, v]) => v.bestKc === bestKc)?.[0] || "" : "";
      const profile = lsGet("petroll-profile");
      try {
        await fetch("/api/leaderboard", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ playerId: profile?.id, name: profile?.name, unique, totalDrops, bestKc, bestPet }),
        });
      } catch {}
    }, 2000);
  }, []);

  useEffect(() => { if (Object.keys(collection).length > 0) schedSave(); }, [collection, schedSave]);

  const loadBoard = useCallback(async () => {
    setLoadingBoard(true);
    try {
      const r = await fetch("/api/leaderboard");
      if (r.ok) setGlobalBoard(await r.json());
    } catch {}
    setLoadingBoard(false);
  }, []);

  useEffect(() => { if (tab === "global") loadBoard(); }, [tab, loadBoard]);

  const speeds = [1, 2, 5, 10, 50, 100];
  const addC = useCallback((t, c = "#000") => { setChat(p => { const n = [...p, { t, c }]; return n.length > 80 ? n.slice(-80) : n; }); }, []);

  const doRoll = useCallback(() => {
    const rate = rRef.current;
    const r = Math.floor(Math.random() * rate) + 1;
    const won = r === 1;
    dRef.current += 1;
    setRolled(r);
    setResult(won ? "win" : "lose");
    setRolls(v => v + 1);
    if (won) {
      const kc = dRef.current;
      setBest(p => (p === null ? kc : Math.min(p, kc)));
      addC(`You have a funny feeling like you're being followed.`, "#ff0000");
      addC(`You received: ${pRef.current.name}! (${fmt(kc)} kc)`, "#00ff00");
      setCollection(prev => {
        const name = pRef.current.name;
        const old = prev[name] || { count: 0, bestKc: Infinity, worstKc: 0, totalKc: 0 };
        return { ...prev, [name]: { count: old.count + 1, bestKc: Math.min(old.bestKc, kc), worstKc: Math.max(old.worstKc, kc), totalKc: old.totalKc + kc } };
      });
      dRef.current = 0; setWins(v => v + 1); setDry(0);
    } else { setDry(dRef.current); }
    return won;
  }, [addC]);

  const roll1 = () => { if (rolling || auto) return; setRolling(true); let t = 0; const iv = setInterval(() => { t++; setRolled(Math.floor(Math.random() * sel.rate) + 1); if (t >= 8) { clearInterval(iv); doRoll(); setRolling(false); } }, 35); };
  const stop = useCallback(() => { setAuto(false); arRef.current = false; if (aRef.current) { clearInterval(aRef.current); aRef.current = null; } }, []);
  const start = () => { addC(`Auto-rolling for ${sel.name} (${rdp(sel)})...`, "#0000ff"); setAuto(true); arRef.current = true; };

  useEffect(() => {
    if (!auto) { if (aRef.current) clearInterval(aRef.current); aRef.current = null; return; }
    const tick = () => { if (!arRef.current) return; const s = spRef.current; const b = s >= 50 ? s : s >= 10 ? s : 1; for (let i = 0; i < b; i++) { if (!arRef.current) break; if (doRoll() && sowRef.current) { stop(); break; } } };
    const ms = speed >= 50 ? 16 : speed >= 10 ? 30 : speed >= 5 ? 60 : speed >= 2 ? 120 : 250;
    aRef.current = setInterval(tick, ms); return () => { if (aRef.current) clearInterval(aRef.current); };
  }, [auto, speed, doRoll, stop]);

  const resetRoll = () => { stop(); setRolls(0); setWins(0); setResult(null); setRolled(null); setDry(0); setBest(null); dRef.current = 0; setChat([{ t: "Roll stats reset. Collection preserved.", c: "#0000ff" }]); };
  const resetCollection = () => { if (!confirmReset) { setConfirmReset(true); setTimeout(() => setConfirmReset(false), 3000); return; } setCollection({}); setConfirmReset(false); lsSet("petroll-collection", {}); addC("Pet collection has been wiped.", "#ff0000"); };

  const saveName = () => {
    const clean = nameInput.trim().slice(0, 16);
    if (!clean) return;
    setPlayerName(clean); setEditingName(false);
    lsSet("petroll-profile", { id: playerId, name: clean });
    schedSave();
  };

  const pick = (p) => { stop(); setSel(p); setRolls(0); setWins(0); setResult(null); setRolled(null); setDry(0); setBest(null); dRef.current = 0; setChat([{ t: `Selected: ${p.name} — Drop rate: ${rdp(p)}`, c: "#0000ff" }]); setOpen(false); setQ(""); };
  const fl = PETS.filter(p => { const mc = cat === "all" || p.cat === cat; const ms = q === "" || p.name.toLowerCase().includes(q.toLowerCase()) || p.source.toLowerCase().includes(q.toLowerCase()); return mc && ms; });

  const collectedPets = Object.entries(collection).filter(([, v]) => v.count > 0);
  const uniqueCount = collectedPets.length;
  const totalPetDrops = collectedPets.reduce((s, [, v]) => s + v.count, 0);
  const globalBest = collectedPets.length > 0 ? Math.min(...collectedPets.map(([, v]) => v.bestKc)) : null;
  const globalWorst = collectedPets.length > 0 ? Math.max(...collectedPets.map(([, v]) => v.worstKc)) : null;
  const hiscoreList = collectedPets.map(([name, data]) => ({ name, ...data, pet: PETS.find(p => p.name === name) })).sort((a, b) => a.bestKc - b.bestKc);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=VT323&display=swap');
        @import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        body{background:#0d0a05;margin:0}
        ::-webkit-scrollbar{width:10px}
        ::-webkit-scrollbar-track{background:#1a1610}
        ::-webkit-scrollbar-thumb{background:linear-gradient(180deg,#5c5040,#3b3424);border:1px solid #6b604a}
        @keyframes popIn{0%{transform:scale(0.7);opacity:0}60%{transform:scale(1.05)}100%{transform:scale(1);opacity:1}}
        @keyframes glow{0%,100%{text-shadow:1px 1px 0 #000,0 0 8px #00ff0033}50%{text-shadow:1px 1px 0 #000,0 0 20px #00ff00aa,0 0 40px #00ff0044}}
      `}</style>
      <div style={{ minHeight: "100vh", background: "#0d0a05", display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "16px 10px", fontFamily: "'VT323',monospace" }}>
        <div style={{ width: "100%", maxWidth: 460, display: "flex", flexDirection: "column", gap: 10 }}>

          {/* Title + Player */}
          <div style={{ ...P.sp, padding: "12px 16px", textAlign: "center", borderBottom: "3px solid #1a1610" }}>
            <h1 style={{ fontFamily: "'Press Start 2P',monospace", fontSize: 13, margin: 0, letterSpacing: 2, ...P.yt }}>OSRS PET ROLLS</h1>
            <div style={{ marginTop: 8, display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
              {editingName ? (
                <>
                  <input value={nameInput} onChange={e => setNameInput(e.target.value)} maxLength={16} onKeyDown={e => e.key === "Enter" && saveName()}
                    style={{ background: "#1a1610", border: "1px solid #5c5040", color: "#ffff00", fontSize: 15, fontFamily: "'VT323',monospace", padding: "3px 8px", outline: "none", textShadow: "1px 1px 0 #000", width: 130, textAlign: "center" }} autoFocus />
                  <button onClick={saveName} style={{ ...P.sb, padding: "3px 8px", fontSize: 12 }}>Save</button>
                  <button onClick={() => setEditingName(false)} style={{ ...P.sb, padding: "3px 8px", fontSize: 12, color: "#5c5040" }}>X</button>
                </>
              ) : (
                <>
                  <span style={{ ...P.ot, fontSize: 15 }}>Playing as: </span>
                  <span style={{ ...P.yt, fontSize: 16 }}>{playerName}</span>
                  <button onClick={() => { setNameInput(playerName); setEditingName(true); }} style={{ ...P.sb, padding: "2px 8px", fontSize: 11, color: "#8b7d5e" }}>Edit</button>
                </>
              )}
            </div>
          </div>

          {/* Selected Pet */}
          <button onClick={() => setOpen(!open)} style={{ ...P.sp, ...P.sb, padding: "12px 16px", display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", textAlign: "left" }}>
            <div><div style={{ ...P.yt, fontSize: 22 }}>{sel.name}</div><div style={{ ...P.ot, fontSize: 14, opacity: 0.7 }}>{sel.source} — <span style={{ color: "#fff" }}>{rdp(sel)}</span></div></div>
            <span style={{ ...P.yt, fontSize: 18, transform: open ? "rotate(180deg)" : "none", transition: "transform 0.2s", display: "inline-block" }}>▼</span>
          </button>

          {open && (
            <div style={{ ...P.sp, overflow: "hidden", maxHeight: 400 }}>
              <div style={{ padding: "10px 10px 6px" }}>
                <input type="text" placeholder="Search pets..." value={q} onChange={e => setQ(e.target.value)}
                  style={{ width: "100%", background: "#1a1610", border: "1px solid #5c5040", color: "#ffff00", fontSize: 16, fontFamily: "'VT323',monospace", padding: "6px 10px", outline: "none", textShadow: "1px 1px 0 #000", boxSizing: "border-box" }} />
              </div>
              <div style={{ display: "flex", gap: 2, padding: "0 10px 8px", flexWrap: "wrap" }}>
                {CATS.map(c => (<button key={c.id} onClick={() => setCat(c.id)} style={{ ...P.sb, padding: "4px 10px", fontSize: 13, background: cat === c.id ? "linear-gradient(180deg,#6b604a,#4a4030)" : "linear-gradient(180deg,#3b3424,#2d2618)", color: cat === c.id ? "#ffff00" : "#8b7d5e" }}>{c.label}</button>))}
              </div>
              <div style={{ maxHeight: 280, overflowY: "auto", borderTop: "2px solid #1a1610" }}>
                {fl.map(p => (
                  <button key={p.name} onClick={() => pick(p)} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", background: sel.name === p.name ? "#2a2318" : "transparent", border: "none", borderBottom: "1px solid #1e1a12", padding: "8px 14px", cursor: "pointer", textAlign: "left", fontFamily: "'VT323',monospace" }}
                    onMouseEnter={e => e.currentTarget.style.background = "#2a2318"} onMouseLeave={e => e.currentTarget.style.background = sel.name === p.name ? "#2a2318" : "transparent"}>
                    <div><div style={{ ...P.yt, fontSize: 16 }}>{p.name}</div><div style={{ color: "#5c5040", fontSize: 13, textShadow: "1px 1px 0 #000" }}>{p.source}</div></div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      {collection[p.name] && <span style={{ color: "#00ff00", fontSize: 12, textShadow: "1px 1px 0 #000" }}>x{collection[p.name].count}</span>}
                      <span style={{ color: cc[p.cat], fontSize: 15, textShadow: "1px 1px 0 #000", whiteSpace: "nowrap" }}>{rdp(p)}</span>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* KC Bar */}
          <div style={{ ...P.sp, padding: "12px 16px", display: "flex", justifyContent: "space-around", textAlign: "center" }}>
            <div><div style={{ color: "#8b7d5e", fontSize: 12, textShadow: "1px 1px 0 #000" }}>Kill Count</div><div style={{ ...P.yt, fontSize: 26 }}>{fmt(rolls)}</div></div>
            <div style={{ width: 1, background: "#5c5040" }} />
            <div><div style={{ color: "#8b7d5e", fontSize: 12, textShadow: "1px 1px 0 #000" }}>Pets</div><div style={{ color: "#00ff00", textShadow: "1px 1px 0 #000", fontFamily: "'VT323',monospace", fontSize: 26 }}>{wins}</div></div>
            <div style={{ width: 1, background: "#5c5040" }} />
            <div><div style={{ color: "#8b7d5e", fontSize: 12, textShadow: "1px 1px 0 #000" }}>Dry Streak</div><div style={{ color: dry > sel.rate ? "#ff3333" : "#ff981f", textShadow: "1px 1px 0 #000", fontFamily: "'VT323',monospace", fontSize: 26 }}>{fmt(dry)}</div></div>
          </div>

          {/* Result + Chat */}
          <div style={{ ...P.sp, overflow: "hidden", borderColor: result === "win" ? "#00ff00" : "#5c5040", transition: "border-color 0.2s" }}>
            <div style={{ padding: "20px", textAlign: "center", minHeight: 100, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: result === "win" ? "linear-gradient(180deg,#0d200a,#0a1808)" : "transparent" }}>
              {result === "win" ? (
                <div style={{ animation: "popIn 0.4s ease-out" }}>
                  <div style={{ color: "#00ff00", fontSize: 28, fontFamily: "'VT323',monospace", animation: "glow 1.5s ease-in-out infinite", marginBottom: 4 }}>{sel.name}</div>
                  <div style={{ color: "#ff0000", fontSize: 16, textShadow: "1px 1px 0 #000, 0 0 6px #ff000044", marginBottom: 4 }}>You have a funny feeling like you're being followed.</div>
                  {best !== null && <div style={{ ...P.ot, fontSize: 14, opacity: 0.8 }}>Luckiest drop: {fmt(best)} kc</div>}
                </div>
              ) : rolled !== null ? (
                <><div style={{ color: "#5c5040", fontSize: 13, textShadow: "1px 1px 0 #000" }}>Rolled</div><div style={{ ...P.ot, fontSize: rolled > 99999 ? 24 : 36 }}>{fmt(rolled)}</div></>
              ) : (<div style={{ color: "#5c5040", fontSize: 16, textShadow: "1px 1px 0 #000" }}>Select a pet and begin your grind</div>)}
            </div>
            <div style={{ background: "#000", borderTop: "2px solid #1a1610", height: 80, overflowY: "auto", padding: "6px 8px" }}>
              {chat.map((m, i) => (<div key={i} style={{ fontFamily: "'VT323',monospace", fontSize: 14, color: m.c, lineHeight: 1.4, textShadow: m.c === "#ff0000" ? "0 0 6px #ff000044" : "none" }}>{m.t}</div>))}
              <div ref={ceRef} />
            </div>
          </div>

          {/* Buttons */}
          <div style={{ display: "flex", gap: 6 }}>
            <button onClick={roll1} disabled={rolling || auto} style={{ ...P.sb, flex: 1, padding: "12px", fontSize: 20, letterSpacing: 3, opacity: rolling || auto ? 0.5 : 1, color: "#ffff00" }}>ROLL</button>
            <button onClick={auto ? stop : start} style={{ ...P.sb, flex: 1, padding: "12px", fontSize: 18, letterSpacing: 2, background: auto ? "linear-gradient(180deg,#8b2020,#5c1010)" : P.sb.background, color: auto ? "#ff3333" : "#ff981f", borderColor: auto ? "#aa3333" : "#6b604a" }}>{auto ? "STOP" : "AUTO"}</button>
            <button onClick={resetRoll} style={{ ...P.sb, padding: "12px 14px", fontSize: 13, color: "#8b7d5e" }}>Reset Rolls</button>
          </div>

          {/* Speed */}
          <div style={{ ...P.sp, padding: "10px 14px" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
              <span style={{ color: "#8b7d5e", fontSize: 14, textShadow: "1px 1px 0 #000" }}>Speed</span><span style={{ ...P.yt, fontSize: 18 }}>{speed}x</span>
            </div>
            <div style={{ display: "flex", gap: 4 }}>
              {speeds.map(s => (<button key={s} onClick={() => setSpeed(s)} style={{ ...P.sb, flex: 1, padding: "5px 0", fontSize: 14, background: speed === s ? "linear-gradient(180deg,#6b604a,#4a4030)" : "linear-gradient(180deg,#2d2618,#1a1610)", color: speed === s ? "#ffff00" : "#5c5040" }}>{s}x</button>))}
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 10, paddingTop: 8, borderTop: "1px solid #3b3424" }}>
              <span style={{ color: "#8b7d5e", fontSize: 14, textShadow: "1px 1px 0 #000" }}>Stop on pet</span>
              <button onClick={() => setSow(!sow)} style={{ width: 44, height: 22, border: "2px solid #5c5040", borderRadius: 0, background: sow ? "linear-gradient(90deg,#1a1610 50%,#00aa00 50%)" : "linear-gradient(90deg,#aa0000 50%,#1a1610 50%)", cursor: "pointer", position: "relative" }}>
                <div style={{ width: 18, height: 18, background: "linear-gradient(180deg,#6b604a,#3b3424)", border: "1px solid #5c5040", position: "absolute", top: 0, left: sow ? 22 : 0, transition: "left 0.15s" }} />
              </button>
            </div>
          </div>

          {/* Tabs */}
          <div style={{ ...P.sp, overflow: "hidden" }}>
            <div style={{ display: "flex", borderBottom: "2px solid #1a1610" }}>
              {[["collection", `Collection (${uniqueCount}/${PETS.length})`], ["hiscores", "My Hiscores"], ["global", "Global Board"]].map(([id, label]) => (
                <button key={id} onClick={() => setTab(id)} style={{ ...P.sb, flex: 1, padding: "8px", fontSize: 13, border: "none", borderBottom: tab === id ? "2px solid #ffff00" : "2px solid transparent", background: tab === id ? "linear-gradient(180deg,#3b3424,#2d2618)" : "linear-gradient(180deg,#252015,#1e1a12)", color: tab === id ? "#ffff00" : "#5c5040", borderRadius: 0 }}>{label}</button>
              ))}
            </div>

            {tab === "collection" && (
              <div style={{ padding: "10px" }}>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: 10 }}>
                  {PETS.map(p => { const d = collection[p.name]; const o = d && d.count > 0; return (
                    <div key={p.name} onMouseEnter={() => { if (o) setHoverPet(p.name); }} onMouseLeave={() => setHoverPet(null)}
                      style={{ width: 52, padding: "4px 2px", background: o ? "#1a2e1a" : "#1a1610", border: `1px solid ${o ? "#2a5a2a" : "#2a2318"}`, textAlign: "center" }}>
                      <div style={{ fontSize: 10, color: o ? "#00ff00" : "#333", textShadow: o ? "1px 1px 0 #000" : "none", fontFamily: "'VT323',monospace", lineHeight: 1.2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.name.length > 8 ? p.name.slice(0, 7) + "." : p.name}</div>
                      {o && <div style={{ fontSize: 11, color: "#ffff00", textShadow: "1px 1px 0 #000", fontFamily: "'VT323',monospace", marginTop: 1 }}>x{d.count}</div>}
                    </div>
                  ); })}
                </div>
                {hoverPet && collection[hoverPet] && (
                  <div style={{ background: "linear-gradient(180deg,#2d2618,#1a1610)", border: "2px solid #5c5040", padding: "8px 12px", marginBottom: 8 }}>
                    <div style={{ ...P.yt, fontSize: 16, marginBottom: 4 }}>{hoverPet}</div>
                    <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                      <div><span style={{ color: "#5c5040", fontSize: 11 }}>Received: </span><span style={{ color: "#00ff00", fontSize: 14, textShadow: "1px 1px 0 #000" }}>{collection[hoverPet].count}</span></div>
                      <div><span style={{ color: "#5c5040", fontSize: 11 }}>Best KC: </span><span style={{ color: "#00ff00", fontSize: 14, textShadow: "1px 1px 0 #000" }}>{fmt(collection[hoverPet].bestKc)}</span></div>
                      <div><span style={{ color: "#5c5040", fontSize: 11 }}>Worst KC: </span><span style={{ color: "#ff3333", fontSize: 14, textShadow: "1px 1px 0 #000" }}>{fmt(collection[hoverPet].worstKc)}</span></div>
                      <div><span style={{ color: "#5c5040", fontSize: 11 }}>Avg KC: </span><span style={{ ...P.ot, fontSize: 14 }}>{fmt(Math.round(collection[hoverPet].totalKc / collection[hoverPet].count))}</span></div>
                    </div>
                  </div>
                )}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderTop: "1px solid #2a2318", paddingTop: 8 }}>
                  <div style={{ display: "flex", gap: 12 }}>
                    <div><div style={{ color: "#5c5040", fontSize: 10 }}>Total Drops</div><div style={{ ...P.yt, fontSize: 16 }}>{totalPetDrops}</div></div>
                    {globalBest !== null && <div><div style={{ color: "#5c5040", fontSize: 10 }}>Best Ever KC</div><div style={{ color: "#00ff00", textShadow: "1px 1px 0 #000", fontFamily: "'VT323',monospace", fontSize: 16 }}>{fmt(globalBest)}</div></div>}
                  </div>
                  <button onClick={resetCollection} style={{ ...P.sb, padding: "4px 10px", fontSize: 12, color: confirmReset ? "#ff3333" : "#5c5040", borderColor: confirmReset ? "#aa3333" : "#6b604a" }}>{confirmReset ? "Confirm Wipe?" : "Wipe Collection"}</button>
                </div>
              </div>
            )}

            {tab === "hiscores" && (
              <div style={{ padding: "8px" }}>
                <div style={{ display: "flex", justifyContent: "space-around", textAlign: "center", padding: "6px 0 10px", borderBottom: "1px solid #2a2318", marginBottom: 6 }}>
                  <div><div style={{ color: "#5c5040", fontSize: 10 }}>Unique</div><div style={{ ...P.yt, fontSize: 20 }}>{uniqueCount}/{PETS.length}</div></div>
                  <div><div style={{ color: "#5c5040", fontSize: 10 }}>Total</div><div style={{ ...P.yt, fontSize: 20 }}>{totalPetDrops}</div></div>
                  {globalBest !== null && <div><div style={{ color: "#5c5040", fontSize: 10 }}>Best KC</div><div style={{ color: "#00ff00", textShadow: "1px 1px 0 #000", fontFamily: "'VT323',monospace", fontSize: 20 }}>{fmt(globalBest)}</div></div>}
                  {globalWorst !== null && <div><div style={{ color: "#5c5040", fontSize: 10 }}>Worst KC</div><div style={{ color: "#ff3333", textShadow: "1px 1px 0 #000", fontFamily: "'VT323',monospace", fontSize: 20 }}>{fmt(globalWorst)}</div></div>}
                </div>
                {hiscoreList.length === 0 ? (<div style={{ textAlign: "center", padding: 20, color: "#5c5040", fontSize: 14 }}>No pets yet. Start rolling!</div>) : (
                  <div style={{ maxHeight: 300, overflowY: "auto" }}>
                    <div style={{ display: "flex", padding: "4px 8px", borderBottom: "1px solid #2a2318" }}>
                      <div style={{ width: 24, color: "#5c5040", fontSize: 11 }}>#</div><div style={{ flex: 1, color: "#5c5040", fontSize: 11 }}>Pet</div>
                      <div style={{ width: 55, color: "#5c5040", fontSize: 11, textAlign: "right" }}>Best</div><div style={{ width: 55, color: "#5c5040", fontSize: 11, textAlign: "right" }}>Worst</div>
                      <div style={{ width: 50, color: "#5c5040", fontSize: 11, textAlign: "right" }}>Avg</div><div style={{ width: 30, color: "#5c5040", fontSize: 11, textAlign: "right" }}>Qty</div>
                    </div>
                    {hiscoreList.map((h, i) => (<div key={h.name} style={{ display: "flex", padding: "5px 8px", borderBottom: "1px solid #1e1a12", alignItems: "center", background: i === 0 ? "#1a2a1a" : "transparent" }}>
                      <div style={{ width: 24, color: i === 0 ? "#ffff00" : i === 1 ? "#ccc" : i === 2 ? "#cc8833" : "#5c5040", fontSize: 14, textShadow: "1px 1px 0 #000", fontFamily: "'VT323',monospace" }}>{i + 1}</div>
                      <div style={{ flex: 1, ...P.yt, fontSize: 14 }}>{h.name}</div>
                      <div style={{ width: 55, textAlign: "right", color: h.bestKc < (h.pet?.rate || 1000) ? "#00ff00" : "#ff981f", fontSize: 13, textShadow: "1px 1px 0 #000", fontFamily: "'VT323',monospace" }}>{fmt(h.bestKc)}</div>
                      <div style={{ width: 55, textAlign: "right", color: "#ff3333", fontSize: 13, textShadow: "1px 1px 0 #000", fontFamily: "'VT323',monospace" }}>{fmt(h.worstKc)}</div>
                      <div style={{ width: 50, textAlign: "right", ...P.ot, fontSize: 13 }}>{fmt(Math.round(h.totalKc / h.count))}</div>
                      <div style={{ width: 30, textAlign: "right", color: "#ffff00", fontSize: 13, textShadow: "1px 1px 0 #000", fontFamily: "'VT323',monospace" }}>x{h.count}</div>
                    </div>))}
                  </div>
                )}
              </div>
            )}

            {tab === "global" && (
              <div style={{ padding: "8px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                  <div style={{ ...P.yt, fontSize: 16 }}>Global Leaderboard</div>
                  <button onClick={loadBoard} style={{ ...P.sb, padding: "3px 10px", fontSize: 12 }}>{loadingBoard ? "..." : "Refresh"}</button>
                </div>
                {globalBoard.length === 0 ? (
                  <div style={{ textAlign: "center", padding: 20, color: "#5c5040", fontSize: 14 }}>{loadingBoard ? "Loading..." : "No players yet. Be the first!"}</div>
                ) : (
                  <div style={{ maxHeight: 320, overflowY: "auto" }}>
                    <div style={{ display: "flex", padding: "4px 8px", borderBottom: "1px solid #2a2318" }}>
                      <div style={{ width: 24, color: "#5c5040", fontSize: 11 }}>#</div><div style={{ flex: 1, color: "#5c5040", fontSize: 11 }}>Player</div>
                      <div style={{ width: 50, color: "#5c5040", fontSize: 11, textAlign: "right" }}>Pets</div><div style={{ width: 45, color: "#5c5040", fontSize: 11, textAlign: "right" }}>Drops</div>
                      <div style={{ width: 60, color: "#5c5040", fontSize: 11, textAlign: "right" }}>Best KC</div>
                    </div>
                    {globalBoard.map((p, i) => { const isMe = p.name === playerName; return (
                      <div key={i} style={{ display: "flex", padding: "5px 8px", borderBottom: "1px solid #1e1a12", alignItems: "center", background: isMe ? "#1a1a2e" : i === 0 ? "#1a2a1a" : "transparent" }}>
                        <div style={{ width: 24, color: i === 0 ? "#ffff00" : i === 1 ? "#ccc" : i === 2 ? "#cc8833" : "#5c5040", fontSize: 14, textShadow: "1px 1px 0 #000", fontFamily: "'VT323',monospace" }}>{i + 1}</div>
                        <div style={{ flex: 1 }}><span style={{ color: isMe ? "#55aaff" : "#ffff00", textShadow: "1px 1px 0 #000", fontFamily: "'VT323',monospace", fontSize: 14 }}>{p.name}</span>{isMe && <span style={{ color: "#55aaff", fontSize: 10, marginLeft: 4 }}>(you)</span>}</div>
                        <div style={{ width: 50, textAlign: "right", ...P.yt, fontSize: 14 }}>{p.unique}/{PETS.length}</div>
                        <div style={{ width: 45, textAlign: "right", ...P.ot, fontSize: 13 }}>{p.totalDrops}</div>
                        <div style={{ width: 60, textAlign: "right" }}><div style={{ color: "#00ff00", fontSize: 13, textShadow: "1px 1px 0 #000", fontFamily: "'VT323',monospace" }}>{p.bestKc ? fmt(p.bestKc) : "—"}</div>{p.bestPet && <div style={{ color: "#5c5040", fontSize: 9 }}>{p.bestPet}</div>}</div>
                      </div>
                    ); })}
                  </div>
                )}
              </div>
            )}
          </div>

          <div style={{ textAlign: "center", padding: "2px 0 10px" }}>
            <span style={{ color: "#1e1a12", fontSize: 11, fontFamily: "'VT323',monospace" }}>Drop rates from OSRS Wiki</span>
          </div>
        </div>
      </div>
    </>
  );
}
